import {Alert} from 'common/alert'
import useGlobalContext from 'containerContext/storeContext'
import {StyledWrapper} from './_styled'

export const Wrapper = ({...props}) => {
  const [globalState] = useGlobalContext()
  const {alert, shouldMinimizeSidebar} = globalState

  const pageLocation = [
    'facebook','notifications'
  ]

  return (
    <StyledWrapper
      {...props}
      style={
        (location.pathname.split('/').length >= 2 && pageLocation.includes(location.pathname.split('/')[1])) ? {paddingBottom: 0} : {paddingBottom: '44px'}
      }
      id={globalState.isLogin ? !!globalState.facebook?.cNabar ? 'facebook-wrap' : 'content-wrap' : ''}
      data-expand={shouldMinimizeSidebar}
    >
      {props?.children}

      {alert?.open && (
        <Alert
          duration={alert?.duration}
          open={true}
          type={alert?.type}
          onClose={alert?.onClose}
        >
          {alert?.content}
        </Alert>
      )}
    </StyledWrapper>
  )
}
